module.exports = __webpack_public_path__ + "static/media/individual-profile.c243755b.svg";